import { ref } from 'vue';

export function useSingleRefComposable<singleRefType = any>() {
    const singleRef = ref<singleRefType|null>(null);

    function setSingleTemplateRef(reference: any) {
        singleRef.value = reference;
    }

    function getSingleTemplateRef(): singleRefType|null {
        return singleRef.value;
    }

    return {
        setSingleTemplateRef,
        getSingleTemplateRef,
        singleRef,
    };
}
